import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import useLocale from '../../../customHooks/useLocale'
import { getLocalizedValue } from '../../../utils/localeUtils'

const RawTypePreview = ({ question }) => {
  const locale = useLocale()
  const localizedContent = getLocalizedValue(question.content, locale)

  return (
    <div title={question.title}>
      <form>{ReactHtmlParser(localizedContent)}</form>
    </div>
  )
}

export default RawTypePreview
